import { useSelector } from "react-redux";
import BreadCrumbsContainer from "../../Common/Breadcrumbs";

import { Outlet } from "react-router-dom";

const ReceiptScreen = () => {
  const sidebar = useSelector(state => state.sidebar);

  return (
    <div className="dashboardOuterContainer">
      {/* <SideBar /> */}
      <div
        className={`${
          sidebar.expand
            ? "dashboardInnerSidebarBig"
            : "dashboardInnerSidebarSmall"
        }`}>
        <BreadCrumbsContainer />
        <div className="dashboardDataCardContainer bg-[#F9F9F9] overflow-x-hidden">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ReceiptScreen;
